export default __webpack_public_path__ + "static/bandera-union-europea-s-f9e0688d6c813d0d72567aaeab26aa4b.jpg";